import { Title } from '@zorro/design-system/v2/Title';
import { Stack, Text } from '@zorro/web/design-system';
import { ReactNode } from 'react';

type StepHeadingProps = {
  title: string;
  subtitle?: string | ReactNode;
  subtitleColor?: string;
  align?: 'left' | 'center' | 'right';
};

export function StepHeading({
  title,
  subtitle,
  subtitleColor = 'zorroGray.4',
  align = 'left',
}: StepHeadingProps) {
  return (
    <Stack align={align} gap="xs">
      <Title ta={align}>{title}</Title>

      {subtitle && (
        <Text ta={align} c={subtitleColor}>
          {subtitle}
        </Text>
      )}
    </Stack>
  );
}
